'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var icon = require('./icon.js');
var space = require('./space.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');
var text = require('./text.js');
var themeGet = require('../utils/themeGet.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-left: 8px;\n  color: ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: #777777;\n  cursor: pointer;\n  align-items: center;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RadioGroupWrapper = styled__default['default'].div(_templateObject(), index.styleEngine);
var Wrapper = styled__default['default'].div(_templateObject2(), index.styleEngine);
var Label = styled__default['default'](text['default'])(_templateObject3(), themeGet['default']('colors.grey.12'), index.styleEngine);

var Radio = function Radio(_ref) {
  var label = _ref.label,
      propChecked = _ref.checked,
      onClick = _ref.onClick,
      labelProps = _ref.labelProps,
      iconProps = _ref.iconProps,
      restProps = _objectWithoutProperties(_ref, ["label", "checked", "onClick", "labelProps", "iconProps"]);

  var _useState = React.useState(propChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useDidUpdate['default'](function () {
    setChecked(checked);
  }, [propChecked]);
  useDidUpdate['default'](function () {
    onClick && onClick(checked);
  }, [checked]);
  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
    onClick: function onClick() {
      return setChecked(!checked);
    },
    checked: checked
  }, restProps), /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({
    icon: checked ? 'pyt-radiobtn-checked-16' : 'pyt-radiobtn-unchecked-16',
    color: checked ? 'primary' : '#AAAAAA',
    fontSize: "14px"
  }, iconProps)), label ? /*#__PURE__*/React__default['default'].createElement(Label, labelProps, label) : null);
};

var RadioGroup = function RadioGroup(_ref2) {
  var propChecked = _ref2.checked,
      onClick = _ref2.onClick,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      onChange = _ref2.onChange,
      _ref2$spaceProps = _ref2.spaceProps,
      spaceProps = _ref2$spaceProps === void 0 ? {} : _ref2$spaceProps,
      _ref2$spaceItemProps = _ref2.spaceItemProps,
      spaceItemProps = _ref2$spaceItemProps === void 0 ? {} : _ref2$spaceItemProps,
      restProps = _objectWithoutProperties(_ref2, ["checked", "onClick", "options", "onChange", "spaceProps", "spaceItemProps"]);

  var _useState3 = React.useState(propChecked),
      _useState4 = _slicedToArray(_useState3, 2),
      checked = _useState4[0],
      setChecked = _useState4[1];

  useDidUpdate['default'](function () {
    setChecked(propChecked);
  }, [propChecked]);
  useDidUpdate['default'](function () {
    onClick && onClick(checked);
    onChange && onChange(checked);
  }, [checked]);
  return /*#__PURE__*/React__default['default'].createElement(RadioGroupWrapper, restProps, /*#__PURE__*/React__default['default'].createElement(space['default'], _extends({
    gutter: 12
  }, spaceProps, {
    itemProps: spaceItemProps,
    width: "100%"
  }), options.map(function (item, inx) {
    var label = item.label,
        labelProps = item.labelProps,
        iconProps = item.iconProps,
        key = item.key,
        restProps = _objectWithoutProperties(item, ["label", "labelProps", "iconProps", "key"]);

    var _key = key || inx;

    var active = checked === _key;
    return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
      onClick: function onClick() {
        return setChecked(_key);
      }
    }, restProps, {
      key: inx
    }), /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({
      icon: active ? 'pyt-radiobtn-checked-16' : 'pyt-radiobtn-unchecked-16',
      color: active ? 'primary' : '#AAAAAA',
      fontSize: "14px"
    }, iconProps)), label ? /*#__PURE__*/React__default['default'].createElement(Label, labelProps, label) : null);
  })));
};
RadioGroup.propTypes = {
  labelProps: PropTypes__default['default'].object,
  label: PropTypes__default['default'].string,
  checked: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  options: PropTypes__default['default'].array,
  spaceProps: PropTypes__default['default'].object,
  spaceItemProps: PropTypes__default['default'].object
};

exports.RadioGroup = RadioGroup;
exports.default = Radio;
